import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

interface Props {
  open: boolean;
  onContinue: () => void;
  onLogout: () => void;
}

export function IdleWarning({ open, onContinue, onLogout }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onContinue()}>
      <DialogContent>
        <DialogHeader>
          <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-warning/15">
            <Clock className="size-6 text-warning" />
          </div>
          <DialogTitle className="text-center">Still there?</DialogTitle>
          <DialogDescription className="text-center">
            For security, your session will end in 1 minute. Move the
            mouse or tap anywhere to stay signed in.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1" onClick={onLogout}>
            Sign out
          </Button>
          <Button className="flex-1" onClick={onContinue}>
            Stay signed in
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
